import React from "react"
import { Link,graphql } from "gatsby"
import Image from "gatsby-image"

import Layout from "../components/layout"
import SEO from "../components/seo"
import HeaderSmall from "../components/headerSmall"
import InsuranceDetailsSection from "../components/insuranceDetailsSection"
import ComparisonTable from "../components/comparisonTable"


export const query = graphql`
    query ($provider: String,$product: String){
      site {
        siteMetadata {
        title,
        year,
        guideyear
        }
      },
      bilforsikring2020Csv(Provider: {eq: $provider}, Product: {eq: $product}){
        Provider
        Product
        Defaqto_Stjerne
      },
      table: allBilforsikring2020Csv(sort: {fields: Defaqto_Stjerne, order: DESC}) {
        edges {
          node{
            Provider
            Product
            Defaqto_Stjerne
          }
        }
      },
    }
  `

export default({data}) => {
  const year = data.site.siteMetadata.year
  const type = "bilforsikring"
  const path = "bil"
  const aspects = "33"

  const provider = data.bilforsikring2020Csv.Provider
  const providerUrl = "" // Not used atm - but should be implemented
  const product = data.bilforsikring2020Csv.Product
  const rating = data.bilforsikring2020Csv.Defaqto_Stjerne

  return(
    <Layout>
      <InsuranceDetailsSection
        table={data.table}
        year={year}
        type={type}
        path={path}
        aspects={aspects}
        provider={provider}
        providerUrl={providerUrl}
        rating={rating}
        product={product}
      />
    </Layout>
  )
}